export const CRLF = '\r\n';
